<template>
  <span>
    <i v-if="open" @click="open = false" class="fas fa-times fill-current text-white h-8 w-full text-center text-2xl"></i>
    <i v-else @click="open = true" class="fas fa-bars fill-current text-white h-8 w-full text-center text-2xl"></i>
    <div :class="open ? 'block bounceInUp': 'bounceOutDown'" class="animated bounceInUp w-full flex-grow sm:flex items-center w-auto absolute bg-blue-darker z-10 rounded-b-lg shadow-md p-3">
      <div class="text-sm sm:flex-grow">
        <router-link class="no-underline block mt-4 sm:inline-block sm:mt-0 text-teal-lighter text-center border-b text-lg pb-3 border-teal-light"
          :to="{ name: 'grid', params: {language: $route.params.language, day:15} }">          
          <i class="fas fa-microphone w-6 fill-current mr-2"></i> 15/10
        </router-link>
        <router-link class="no-underline block mt-4 sm:inline-block sm:mt-0 text-teal-lighter text-center border-b text-lg pb-3 border-teal-light"
          :to="{ name: 'grid', params: {language: $route.params.language, day:16} }">          
          <i class="fas fa-microphone w-6 fill-current mr-2"></i> 16/10
        </router-link>
        <router-link class="no-underline block mt-4 sm:inline-block sm:mt-0 text-teal-lighter text-center border-b text-lg pb-3 border-teal-light"
          :to="{ name: 'grid', params: {language: $route.params.language, day:17} }">
          <i class="fas fa-microphone w-6 fill-current mr-2"></i> 17/10
        </router-link>
        <router-link class="no-underline block mt-4 sm:inline-block sm:mt-0 text-teal-lighter text-center border-b text-lg pb-3 border-teal-light"
          :to="{ name: 'grid', params: {language: $route.params.language, day:18} }">
          <i class="fas fa-microphone w-6 fill-current mr-2"></i> 18/10
        </router-link>
        <a href="https://www.futurecom.com.br/" target="_blank" class="no-underline block mt-4 sm:inline-block sm:mt-0 text-teal-lighter text-center border-b text-lg pb-3 border-teal-light">
          <i class="fas fa-link w-6 fill-current mr-2"></i>
          Site Oficial
        </a>
        <a href="https://www.futurecom.com.br/pt/inscreva-se.html" target="_blank" class="bg-orange border border-orange-dark hover:bg-orange-light shadow text-white text-lg p-3 mt-3 rounded no-underline font-sans font-bold uppercase invisible sm:invisible md:visible">
          <span v-if="$route.params.language === 'pt'">Adquirir ingresso</span>
          <span v-if="$route.params.language === 'en'">Buy ticket</span>
          <span v-if="$route.params.language === 'es'">Adquirir ingreso</span>
        </a>
      </div>
      <!-- <div>
        <a href="#" class="no-underline w-full text-center font-sans font-bold inline-block text-sm px-4 py-2 leading-none border rounded text-orange border-orange mt-4 sm:mt-0">Fazer Inscrição</a>
      </div> -->
    </div>  
  </span>
</template>
<script>
  export default {
    name: 'NavMobile',
    data() {
      return{
        days: {},
        open: false,
      }
    },
    methods: {
      toggle() {
        this.open = !this.open
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layout/NavMobile.vue